import { render, staticRenderFns } from "./OposSearchPanel.vue?vue&type=template&id=07ade49a&"
import script from "./OposSearchPanel.vue?vue&type=script&lang=js&"
export * from "./OposSearchPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports